export function countUniqueBidders(bids = [] as any[]) {
  let uniqueBidders = [] as number[];
  bids.forEach((bid: any) => {
    if (!uniqueBidders.includes(bid.customer_id + bid.customer_type)) {
      uniqueBidders.push(bid.customer_id + bid.customer_type);
    }
  });
  return uniqueBidders.length;
}
